import { Nav, Navbar } from 'react-bootstrap';
import '../interfaceSettings.css';
import { Outlet, useNavigate } from 'react-router-dom';
import { exportAnalyticsData } from '../components/Admin/ExcelExport';

// TODO: (Scope: High, Priority: Low)
//       Create two analytics panels for admins to view user & video analytics.
//       Fetch, process, and display data on overall user demographics and basic video statistics.
//       Custom queries? Maybe use an external library?

const AdminAnalytics = () => {
    const navigate = useNavigate();

    return (
        <div className="container-fluid px-3">
            <div className="d-md-flex">
                {/* Sidepane */}
                <div>
                    <hr />
                    <Navbar className="text-nowrap d-flex flex-column justify-content-start">
                        <div className="btn btn-light mb-2 w-100">
                            <Nav.Link className="hover" onClick={() => navigate('/adminAnalytics/videos')}>🎞️ Video Analytics</Nav.Link>
                        </div>
                        <div className="btn btn-light mb-2 w-100">
                            <Nav.Link className="hover" onClick={() => navigate('/adminAnalytics/users')}>📊 User Demographics</Nav.Link>
                        </div>
                        <div className="btn btn-light mb-2 w-100">
                            <Nav.Link className="hover" onClick={() => navigate('/adminAnalytics/trails')}>🌿 Trail Analytics</Nav.Link>
                        </div>
                        <div className="btn btn-primary w-100">
                            <Nav.Link className="hover" onClick={exportAnalyticsData}>Export Data</Nav.Link>
                        </div>
                    </Navbar>
                    <br />
                    <hr />
                </div>
                <div className="ms-md-4 w-100">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default AdminAnalytics;
